<template>
  <div>
    <ASearchForm
      :modelName="'Transfer Order'"
      :create="false"
      :dropdownProps="[{type:'text',name: 'Transfer Order ID (contains)', payloadKey: 'name'}, {model:'locations', name: 'Location', payloadKey: 'locationId'}]"
      @change="search"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <TrackingOrderLog ref="refLog" :apiParams="apiParams" :exportable="true"></TrackingOrderLog>
  </div>
</template>

<script>
import CRUDFuncsMixin from "../../mixins/CRUDFuncs";
import ASearchForm from "../../components/ASearchForm";
import TrackingOrderLog from "./components/log";
import ADataTable from "../../components/ADataTable";
import logApi from "../../api/log";

export default {
  name: "TOLog",
  mixins: [CRUDFuncsMixin],
  components: {
    ASearchForm,
    ADataTable,
    TrackingOrderLog
  },
  data() {
    return {
      apiParams: {}
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>



